export const ALL_BUS_COMPANY = 'TODOS'
